module.exports = __webpack_public_path__ + "img/success.7cbfb9dc.png";